:host {
  display: block;
}

.error-container {
  @apply container mx-auto p-3 items-center;
  color: var(--color-error);
}
